import React from 'react';

import { DangerouslySetInnerHtml } from '../DangerouslySetInnerHtml/DangerouslySetInnerHtml';
import { LayoutWrapper } from '../LayoutWrapper/LayoutWrapper';
import { Title } from '../Title/Title';
import { Usp } from '../Usp/Usp';
import styles from './BusinessTopBlock.module.css';

export type TitleSubtitleBlockPresentational = {
  subtitle: string;
  title: string;
};

export type Props = {
  topBlockDescription: string | null;
  topBlockTitle: string | null;
  topBlockUsps: TitleSubtitleBlockPresentational[];
};

export const BusinessTopBlock = React.memo((props: Props) => {
  const {
    topBlockTitle,
    topBlockUsps,
    topBlockDescription,
  } = props;

  return (topBlockTitle || topBlockUsps?.length || topBlockDescription) ? (
    <LayoutWrapper>
      <div className={styles.businessTopBlock}>
        <div className={styles.leftColumn}>
          {topBlockTitle
            ? <Title variant='h2' title={topBlockTitle} />
            : null}

          {topBlockUsps?.length
            ? <div className={styles.usps}>
              {topBlockUsps.map((usp, index) => (
                <Usp
                  key={index}
                  subTitle={usp.subtitle}
                  uspClassName={styles.uspItemText}
                  iconClassName={styles.uspItemImage}
                >
                  {usp.title}
                </Usp>
              ))}
            </div>
            : null}
        </div>

        {topBlockDescription
          ? <DangerouslySetInnerHtml
            variant={'body1'}
            className={styles.rightColumn}
            dangerousHtml={topBlockDescription}
          />
          : null}
      </div>
    </LayoutWrapper>
  ) : null;
});

BusinessTopBlock.displayName = 'BusinessTopBlock';
